// English mirror of nav.ts. For Phase 1 the linked pages don't all exist
// in English yet — items keep their Swedish target paths so the
// LanguageSwitcher fallback (to /en) catches them gracefully.

import type { NavEntry } from "./nav";
import { serviceAreaPanels } from "./service-areas";
import { audiences } from "./audiences";

const audienceLabelsEn: Record<string, { label: string; intro: string }> = {
  grundare: { label: "Founders", intro: "Tell your story to investors and the market" },
  marknadsteam: { label: "Marketing teams", intro: "Premium video flow on subscription" },
  byraer: { label: "Agencies", intro: "Production partner for your retainer clients" },
  forbund: { label: "Trade bodies", intro: "Member communication that actually lands" },
  "some-team": { label: "Social teams", intro: "On-brand cuts for every channel, every week" },
};

export const navEn: NavEntry[] = [
  ...serviceAreaPanels("en"),

  {
    kind: "mega",
    label: "Who it's for",
    activeWhen: ["/for-vem", "/heritage", "/brollopsfilm"],
    columns: [
      {
        eyebrow: "Business",
        items: audiences
          .map((a) => ({
            to: a.to,
            label: audienceLabelsEn[a.slug]?.label ?? a.label,
            desc: audienceLabelsEn[a.slug]?.intro ?? a.intro,
          }))
          .concat([
            {
              to: "/en/heritage/kunskapsarv",
              label: "Knowledge transfer",
              desc: "Capture senior expertise before retirement.",
            },
            { to: "/for-vem", label: "All tracks", desc: "Find your match" },
          ]),
      },
      {
        eyebrow: "Private",
        items: [
          {
            to: "/brollopsfilm",
            label: "Couples",
            desc: "Cinematic wedding film — 1–3 weddings per year.",
          },
          {
            to: "/en/heritage/livsberattelser",
            label: "Families",
            desc: "Life stories on film, for future generations.",
          },
          {
            to: "/en/heritage/kunskapsarv",
            label: "Master crafters",
            desc: "Capture the knowledge before it disappears.",
          },
          {
            to: "/en/heritage",
            label: "Heritage",
            desc: "Life stories and knowledge legacy",
          },
        ],
      },
    ],
    featured: {
      eyebrow: "Help me choose",
      title: "Business or private?",
      body: "Two worlds, same craft. See which track matches you.",
      to: "/for-vem",
      cta: "See overview",
    },
  },
  { kind: "link", to: "/case", label: "Work" },
  {
    kind: "mega",
    label: "Resources",
    activeWhen: ["/kunskap", "/faq", "/partners", "/guider"],
    columns: [
      {
        eyebrow: "Read & learn",
        items: [
          { to: "/kunskap", label: "Blog", desc: "Articles, perspectives, craft" },
          { to: "/faq", label: "FAQ", desc: "What we're asked most often" },
        ],
      },
      {
        eyebrow: "Proof",
        items: [
          { to: "/partners", label: "Partners", desc: "Agencies and platforms we work with" },
        ],
      },
      {
        eyebrow: "Tools",
        items: [{ to: "/guider", label: "Guides", desc: "Practical downloads" }],
      },
    ],

    featured: {
      eyebrow: "New for 2026",
      title: "Format guide 2026",
      body: "A PDF that shows which format works where — feed, story, YouTube, webinar.",
      to: "/guider",
      cta: "Download",
    },
  },
];
